<template>
  <div class="">
    <create-custom-attributes> </create-custom-attributes>
  </div>
</template>

<script>
import CreateCustomAttributes from "@/components/profile/custom-attributes/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CreateCustomAttributes,
  },
  created() {
    this.notifyQueue({
      text: "Crea Campo Aggiuntivo",
      path: "attributes.create",
      level: 3,
    });
  },
};
</script>
